export default __webpack_public_path__ + "static/media/output.32fd0240.mp3";